import React from 'react';
import LocationTemplate from './LocationTemplate';

const EnfieldPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Enfield"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27823"]}
      latitude={36.179}
      longitude={-77.68}
      population={2300}
      historicalFact="Established in 1740; site of Randolph's Rebellion, an early protest against unfair British taxation in 1759."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Halifax, NC",
        "Whitakers, NC",
        "Scotland Neck, NC",
        "Roanoke Rapids, NC",
        "Weldon, NC",
        "Hobgood, NC",
        "Leggett, NC"
      ]}
    />
  );
};

export default EnfieldPage;